const ARROW_SIZE = 64

let cachedAtlas = null

export function getVehicleGpsArrowIcon() {
    if (cachedAtlas) {
        return cachedAtlas
    }

    const canvas = document.createElement('canvas')
    canvas.width = ARROW_SIZE
    canvas.height = ARROW_SIZE

    const ctx = canvas.getContext('2d')
    ctx.clearRect(0, 0, ARROW_SIZE, ARROW_SIZE)
    ctx.fillStyle = '#ffffff'
    ctx.beginPath()
    ctx.moveTo(ARROW_SIZE / 2, 6)
    ctx.lineTo(ARROW_SIZE - 10, ARROW_SIZE - 8)
    ctx.lineTo(ARROW_SIZE / 2, ARROW_SIZE - 18)
    ctx.lineTo(10, ARROW_SIZE - 8)
    ctx.closePath()
    ctx.fill()

    cachedAtlas = {
        atlas: canvas,
        mapping: {
            arrow: {
                x: 0,
                y: 0,
                width: ARROW_SIZE,
                height: ARROW_SIZE,
                mask: true,
                anchorX: ARROW_SIZE / 2,
                anchorY: ARROW_SIZE / 2,
            },
        },
    }

    return cachedAtlas
}

/** deck.gl IconLayer angle: CCW degrees; icon texture points north at bearing 0. */
export function bearingToIconAngle(bearing) {
    if (!Number.isFinite(bearing)) {
        return 0
    }
    return -bearing
}
